/* eslint-disable import/prefer-default-export */
import { watch } from 'vue';
import { useStore } from 'vuex';
import { useI18n } from 'vue-i18n';
import { ls } from '@sfe/bone-cache';
import { setLocale } from '@/locales/i18n';
import { monitor, reportToken, monitorTypes } from '@/utils/monitor';

export async function getByGlobalsComponent(
    /** 组件名 */
    componentName,
    /** 组件属性，如组件已加载，且属性有值，组件支持更新属性，则更新属性，如组件未加载，会会尝试加载组件并传入 */
    componentProps,
    /** 组件容器 ID，如果组件未加载，则会尝试加载组件并传入 */
    containerId,
) {
    if (!window?.ByGlobals) {
        return null;
    }
    let instance = null;
    try {
        instance = await window.ByGlobals.getComponentInstance(componentName);

        if (instance) {
            // 组件已存在，如果存在配置有更新
            if (instance.update && componentProps) {
                instance.update(componentProps);
            }
        } else {
            // 动态加载
            instance = await window.ByGlobals.loadComponent(
                componentName,
                containerId,
                componentProps,
            );

            if (!instance) {
                console.error(`${componentName} instance is not found`);
            }
        }
    } catch (err) {
        console.error(
            `Getting ${componentName} instance Error: `,
            err?.message ?? 'Unknown',
        );
    }
    return instance;
}

export function useUniFrame() {
    const i18n = useI18n({ useScope: 'global' });
    const store = useStore();

    // Cookie改造后，ROUTE_CHOSEN_STORAGE_KEY做了修改，删除旧Key('by_route_chosen')，新Key是'route_chosen_v2'；
    ls.remove('by_route_chosen');
    const init = async () => {
        monitor.mark('metric_uni_header_ready', monitorTypes.PAGE_START);
        const adaBot = await getByGlobalsComponent('ada', {
            locale: i18n.locale.value,
        });
        const header = await getByGlobalsComponent('navHeader', {
            language: i18n.locale.value,
            onLanguageChange: (locale) => {
                setLocale({ locale, redirect: true });
                adaBot?.update({
                    locale,
                });
            },
            onLogout: () => {
                store.dispatch('user/LOGOUT').then(() => {
                    reportToken('uni_header_logout');
                    window.location.reload(true);
                });
            },
        }, '__bybit_uniframe_header__');
        await getByGlobalsComponent('navFooter', {
            locale: i18n.locale.value,
        }, '__bybit_uniframe_footer__');
        watch(() => store.state.user.userstate, () => {
            if (store.state.user.userstate === -1) {
                header.update({
                    userInfo: {},
                });
                adaBot.update({
                    userInfo: {},
                });
            } else if (store.state.user.userstate === 1) {
                header.update({
                    userInfo: store.state.user.info,
                });
                adaBot.update({
                    userInfo: store.state.user.info,
                });
            }
        }, { immediate: true });
    };

    return {
        init,
    };
}

// uniframe 是否就绪
export const isUniframe = () => window.ByGlobals && typeof window.ByGlobals.loadComponent === 'function';

export const ready = () => {
    if (isUniframe()) return Promise.resolve();
    return new Promise((done) => {
        window.addEventListener('load', () => {
            if (isUniframe()) done();
        });
    });
};
